import { Routes, Route } from "react-router-dom";
import "./App.css";
import Register from "./Components/Register";
import Login from "./Components/Login";
import PersonalDetails from "./pages/PaitentDash";
import DoctorDashboard from "./pages/DoctorDash";

import AllData from "./Components/Admin/AllData";

import AdminPage from "./pages/AdminPage";
import PersonalDetailsDocter from "./pages/PersonalDetails";
import Home from "./Components/Home/Home/Home";
import SearchDoctor from "./pages/SearchDoctor";
import Appointments from "./pages/Appointments";
import CreateAppointment from "./pages/CreateAppointment";
import TodaysSchedule from "./Components/TodaysSchedule";
import DocAppointments from "./pages/PaymentHistory";
import DoctorChatting from "./pages/chatwithdoctor";
import PatientChatting from "./pages/chatwithpatient";
import Doctor from "./pages/admin/doctor"
import User from "./pages/admin/user";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/paitentDash" element={<PersonalDetails />} />
        <Route path="/doctorDash" element={<DoctorDashboard />} />
        <Route
          path="/doctor/perosnaldetails"
          element={<PersonalDetailsDocter />}
        />
        <Route path="/patient/searchdoctor" element={<SearchDoctor />} />
        <Route path="/patient/appointments" element={<Appointments />} />
        <Route
          path="/patient/createappointment/:doctor"
          element={<CreateAppointment />}
        />
        <Route path="/doctor" element={<TodaysSchedule />} />
        <Route path="/doctor/payment-history" element={<DocAppointments />} />
        {/* <Route path="/adminLogin" element={<AdminLogin />} /> */}
        <Route path="/allAdminData" element={<AllData />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/doctorList" element={<Doctor />} />
        <Route path="/userList" element={<User />} />
        <Route path="/chatwithdoctor" element={<DoctorChatting />} />
        <Route path="/chatwithpatient" element={<PatientChatting />} />
      </Routes>
    </div>
  );
}

export default App;
